var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticStyle:{"width":"100%","height":"calc(100% - 56px - 48px)","position":"absolute","overflow":"scroll","left":"0","top":"56px"},attrs:{"headers":_vm.headers,"items":_vm.data,"items-per-page":-1}})}
var staticRenderFns = []

export { render, staticRenderFns }